import { APIPlan, NewPlan, Plan, UpdatePlan, parseAPIPlan } from "models/plan"
import { PaginatedData } from "utils/pagination"
import { api } from "./api"

export const getPlan = async (id: string): Promise<Plan> => {
  const { data } = await api.get<{ data: APIPlan }>(`/v1/plans/${id}`)
  return parseAPIPlan(data.data)
}

export const getPlans = async (page: number, perPage: number, selectedProvider?: string): Promise<PaginatedData<Plan>> => {
  const query = new URLSearchParams()

  query.append("page", page.toString())
  query.append("perPage", perPage.toString())

  if (selectedProvider) {
    query.append("providerId", selectedProvider)
  }

  const { data } = await api.get<PaginatedData<APIPlan>>(`/v1/plans?${query.toString()}`)
  return {
    ...data,
    data: data.data.map(parseAPIPlan)
  }
}

export const changePlanStatus = async (planId: string, status: "active" | "inactive"): Promise<void> => {
  await api.patch(`/v1/plans/${planId}/status`, { status })
}

export const addPlan = async (plan: NewPlan): Promise<string> => {
  const { data } = await api.post<{ data: { id: string } }>("/v1/plans", plan)
  return data.data.id
}

export const updatePlan = async (planId: string, plan: UpdatePlan): Promise<void> => {
  await api.put(`/v1/plans/${planId}`, plan)
}

export const deletePlan = async (id: string): Promise<void> => {
  await api.delete(`/v1/plans/${id}`)
}
